import * as actionType from '../actionTypes/gameActionTypes'
import { ActionFormat } from './actionFormats'

export const fetchPartnersRequest = (): ActionFormat => ({
  type: actionType.FETCH_PARTNERS_REQUEST,
})

export const fetchPartnersSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_PARTNERS_SUCCESS,
  payload,
})

export const fetchPartnersFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_PARTNERS_FAILURE,
  payload,
})

export const fetchInitialDataRequest = (payload: string): ActionFormat => ({
  type: actionType.FETCH_INITIAL_DATA_REQUEST,
  payload,
})

export const fetchInitialDataSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_INITIAL_DATA_SUCCESS,
  payload,
})

export const fetchInitialDataFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_INITIAL_DATA_FAILURE,
  payload,
})

export const checkIfTimerIsSetRequest = (): ActionFormat => ({
  type: actionType.CHECK_TIMER_SET_REQUEST,
})

export const checkIfTimerIsSetSuccess = (payload: any): ActionFormat => ({
  type: actionType.CHECK_TIMER_SET_SUCCESS,
  payload,
})

export const checkIfTimerIsSetFailure = (payload: any): ActionFormat => ({
  type: actionType.CHECK_TIMER_SET_FAILURE,
  payload,
})

export const postFreeGameLoginRequest = (payload: any): ActionFormat => ({
  type: actionType.POST_FREE_GAME_LOGIN_REQUEST,
  payload,
})

export const postFreeGameLoginSuccess = (payload: any): ActionFormat => ({
  type: actionType.POST_GAME_CODE_SUCCESS,
  payload,
})

export const postFreeGameLoginFailure = (payload: any): ActionFormat => ({
  type: actionType.POST_GAME_CODE_FAILURE,
  payload,
})

export const postGameCodeRequest = (payload: any): ActionFormat => ({
  type: actionType.POST_GAME_CODE_REQUEST,
  payload,
})

export const postGameCodeSuccess = (payload: any): ActionFormat => ({
  type: actionType.POST_GAME_CODE_SUCCESS,
  payload,
})

export const postGameCodeFailure = (payload: any): ActionFormat => ({
  type: actionType.POST_GAME_CODE_FAILURE,
  payload,
})

export const addTeamNameRequest = (payload: any): ActionFormat => ({
  type: actionType.POST_TEAM_NAME_REQUEST,
  payload,
})

export const addTeamNameSuccess = (payload: any): ActionFormat => ({
  type: actionType.POST_TEAM_NAME_SUCCESS,
  payload,
})

export const addTeamNameFailure = (payload: any): ActionFormat => ({
  type: actionType.POST_TEAM_NAME_FAILURE,
  payload,
})

export const checkIfTeamNameIsAddedRequest = (): ActionFormat => ({
  type: actionType.CHECK_IF_TEAM_NAME_IS_ADDED_REQUEST,
})

export const checkIfTeamNameIsAddedSuccess = (payload: any): ActionFormat => ({
  type: actionType.CHECK_IF_TEAM_NAME_IS_ADDED_SUCCESS,
  payload,
})

export const checkIfTeamNameIsAddedFailure = (payload: any): ActionFormat => ({
  type: actionType.CHECK_IF_TEAM_NAME_IS_ADDED_FAILURE,
  payload,
})

export const putTeamNameRequest = (payload: any): ActionFormat => ({
  type: actionType.PUT_TEAM_NAME_REQUEST,
  payload,
})

export const putTeamNameSuccess = (payload: any): ActionFormat => ({
  type: actionType.PUT_TEAM_NAME_SUCCESS,
  payload,
})

export const putTeamNameFailure = (payload: any): ActionFormat => ({
  type: actionType.PUT_TEAM_NAME_FAILURE,
  payload,
})

export const bookGameRequest = (payload: any): ActionFormat => ({
  type: actionType.POST_BOOK_GAME_REQUEST,
  payload,
})

export const bookGameSuccess = (payload: any): ActionFormat => ({
  type: actionType.POST_BOOK_GAME_SUCCESS,
  payload,
})

export const bookGameFailure = (payload: any): ActionFormat => ({
  type: actionType.POST_BOOK_GAME_FAILURE,
  payload,
})

export const fetchBookedGamesByUserRequest = (): ActionFormat => ({
  type: actionType.FETCH_BOOKED_GAMES_BY_USER_REQUEST,
})

export const fetchBookedGamesByUserSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_BOOKED_GAMES_BY_USER_SUCCESS,
  payload,
})

export const fetchBookedGamesByUserFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_BOOKED_GAMES_BY_USER_FAILURE,
  payload,
})

export const fetchBookedGamesByCitiesRequest = (): ActionFormat => ({
  type: actionType.FETCH_BOOKED_GAMES_BY_CITIES_REQUEST,
})

export const fetchBookedGamesByCitiesSuccess = (
  payload: any,
): ActionFormat => ({
  type: actionType.FETCH_BOOKED_GAMES_BY_CITIES_SUCCESS,
  payload,
})

export const fetchBookedGamesByCitiesFailure = (
  payload: any,
): ActionFormat => ({
  type: actionType.FETCH_BOOKED_GAMES_BY_CITIES_FAILURE,
  payload,
})

export const fetchBookedGamesTotalsInRangeRequest = (): ActionFormat => ({
  type: actionType.FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_REQUEST,
})

export const fetchBookedGamesTotalsInRangeSuccess = (
  payload: any,
): ActionFormat => ({
  type: actionType.FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_SUCCESS,
  payload,
})

export const fetchBookedGamesTotalsInRangeFailure = (
  payload: any,
): ActionFormat => ({
  type: actionType.FETCH_BOOKED_GAMES_TOTALS_IN_RANGE_FAILURE,
  payload,
})

export const fetchBookedGamesTotalsRequest = (): ActionFormat => ({
  type: actionType.FETCH_BOOKED_GAMES_TOTALS_REQUEST,
})

export const fetchBookedGamesTotalsSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_BOOKED_GAMES_TOTALS_SUCCESS,
  payload,
})

export const fetchBookedGamesTotalsFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_BOOKED_GAMES_TOTALS_FAILURE,
  payload,
})

export const fetchLeaderboardRequest = (payload: any): ActionFormat => ({
  type: actionType.FETCH_LEADERBOARD_REQUEST,
  payload,
})

export const fetchLeaderboardSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_LEADERBOARD_SUCCESS,
  payload,
})

export const fetchLeaderboardFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_LEADERBOARD_FAILURE,
  payload,
})

export const fetchTeamOnLeaderboardRequest = (): ActionFormat => ({
  type: actionType.FETCH_TEAM_ON_LEADERBOARD_REQUEST,
})

export const fetchTeamOnLeaderboardSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_TEAM_ON_LEADERBOARD_SUCCESS,
  payload,
})

export const fetchTeamOnLeaderboardFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_TEAM_ON_LEADERBOARD_FAILURE,
  payload,
})

export const fetchGamesByUserRequest = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAMES_BY_USER_REQUEST,
  payload,
})

export const fetchGamesByUserSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAMES_BY_USER_SUCCESS,
  payload,
})

export const fetchGamesByUserFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAMES_BY_USER_FAILURE,
  payload,
})

export const fetchGameCodeRequest = (): ActionFormat => ({
  type: actionType.FETCH_GAME_CODE_REQUEST,
})

export const fetchGameCodeSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAME_CODE_SUCCESS,
  payload,
})

export const fetchGameCodeFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAME_CODE_FAILURE,
  payload,
})

export const fetchWelcomeScreenRequest = (payload: any): ActionFormat => ({
  type: actionType.FETCH_WELCOME_SCREEN_REQUEST,
  payload,
})

export const fetchWelcomeScreenSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_WELCOME_SCREEN_SUCCESS,
  payload,
})

export const fetchWelcomeScreenFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_WELCOME_SCREEN_FAILURE,
  payload,
})

export const fetchEndScreenRequest = (localeId: number): ActionFormat => ({
  type: actionType.FETCH_END_SCREEN_REQUEST,
  payload: localeId,
})

export const fetchEndScreenSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_END_SCREEN_SUCCESS,
  payload,
})

export const fetchEndScreenFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_END_SCREEN_FAILURE,
  payload,
})

export const fetchGameLocalesRequest = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAME_LOCALES_REQUEST,
  payload,
})

export const fetchGameLocalesSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAME_LOCALES_SUCCESS,
  payload,
})

export const fetchGameLocalesFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAME_LOCALES_FAILURE,
  payload,
})

export const fetchMapStyleRequest = (): ActionFormat => ({
  type: actionType.FETCH_MAP_STYLE_REQUEST,
})

export const fetchMapStyleSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_MAP_STYLE_SUCCESS,
  payload,
})

export const fetchMapStyleFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_MAP_STYLE_FAILURE,
  payload,
})

export const fetchLocationsOnMapRequest = (): ActionFormat => ({
  type: actionType.FETCH_LOCATIONS_ON_MAP_REQUEST,
})

export const fetchLocationsOnMapSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_LOCATIONS_ON_MAP_SUCCESS,
  payload,
})

export const fetchLocationsOnMapFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_LOCATIONS_ON_MAP_FAILURE,
  payload,
})

export const postPuzzleAnswerRequest = (payload: any): ActionFormat => ({
  type: actionType.POST_PUZZLE_ANSWER_REQUEST,
  payload,
})

export const postPuzzleAnswerSuccess = (payload: any): ActionFormat => ({
  type: actionType.POST_PUZZLE_ANSWER_SUCCESS,
  payload,
})

export const postPuzzleAnswerFailure = (payload: any): ActionFormat => ({
  type: actionType.POST_PUZZLE_ANSWER_FAILURE,
  payload,
})

export const fetchQuestionByLocaleRequest = (payload: any): ActionFormat => ({
  type: actionType.FETCH_QUESTION_BY_LOCALE_REQUEST,
  payload,
})

export const fetchQuestionByLocaleSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_QUESTION_BY_LOCALE_SUCCESS,
  payload,
})

export const fetchQuestionByLocaleFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_QUESTION_BY_LOCALE_FAILURE,
  payload,
})

export const fetchQuestionSolvedPuzzleByLocaleRequest = (
  payload: any,
): ActionFormat => ({
  type: actionType.FETCH_QUESTION_SOLVED_PUZZLE_BY_LOCALE_REQUEST,
  payload,
})

export const fetchQuestionSolvedPuzzleByLocaleSuccess = (
  payload: any,
): ActionFormat => ({
  type: actionType.FETCH_QUESTION_SOLVED_PUZZLE_BY_LOCALE_SUCCESS,
  payload,
})

export const fetchQuestionSolvedPuzzleByLocaleFailure = (
  payload: any,
): ActionFormat => ({
  type: actionType.FETCH_QUESTION_SOLVED_PUZZLE_BY_LOCALE_FAILURE,
  payload,
})

export const fetchIsQuestionSolvedRequest = (payload: any): ActionFormat => ({
  type: actionType.FETCH_IS_QUESTION_SOLVED_REQUEST,
  payload,
})

export const fetchIsQuestionSolvedSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_IS_QUESTION_SOLVED_SUCCESS,
  payload,
})

export const fetchIsQuestionSolvedFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_IS_QUESTION_SOLVED_FAILURE,
  payload,
})

export const postPuzzleHintRequest = (payload: any): ActionFormat => ({
  type: actionType.POST_PUZZLE_HINT_REQUEST,
  payload,
})

export const postPuzzleHintSuccess = (payload: any): ActionFormat => ({
  type: actionType.POST_PUZZLE_HINT_SUCCESS,
  payload,
})

export const postPuzzleHintFailure = (payload: any): ActionFormat => ({
  type: actionType.POST_PUZZLE_HINT_FAILURE,
  payload,
})

export const fetchUsedHintsRequest = (payload: any): ActionFormat => ({
  type: actionType.FETCH_USED_HINTS_REQUEST,
  payload,
})

export const fetchUsedHintsSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_USED_HINTS_SUCCESS,
  payload,
})

export const fetchUsedHintsFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_USED_HINTS_FAILURE,
  payload,
})

export const postSkipPuzzleRequest = (payload: any): ActionFormat => ({
  type: actionType.POST_SKIP_PUZZLE_REQUEST,
  payload,
})

export const postSkipPuzzleSuccess = (payload: any): ActionFormat => ({
  type: actionType.POST_SKIP_PUZZLE_SUCCESS,
  payload,
})

export const postSkipPuzzleFailure = (payload: any): ActionFormat => ({
  type: actionType.POST_SKIP_PUZZLE_FAILURE,
  payload,
})

export const fetchLegalUrlsRequest = (): ActionFormat => ({
  type: actionType.FETCH_LEGAL_URLS_REQUEST,
})

export const fetchLegalUrlsSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_LEGAL_URLS_SUCCESS,
  payload,
})

export const fetchLegalUrlsFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_LEGAL_URLS_FAILURE,
  payload,
})

export const fetchCollectedItemsRequest = (payload: any): ActionFormat => ({
  type: actionType.FETCH_COLLECTED_ITEMS_REQUEST,
  payload,
})

export const fetchCollectedItemsSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_COLLECTED_ITEMS_SUCCESS,
  payload,
})

export const fetchCollectedItemsFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_COLLECTED_ITEMS_FAILURE,
  payload,
})

export const fetchFinalPuzzleRequest = (payload: any): ActionFormat => ({
  type: actionType.FETCH_FINAL_PUZZLE_REQUEST,
  payload,
})

export const fetchFinalPuzzleSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_FINAL_PUZZLE_SUCCESS,
  payload,
})

export const fetchFinalPuzzleFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_FINAL_PUZZLE_FAILURE,
  payload,
})

export const fetchTeamNameRequest = (): ActionFormat => ({
  type: actionType.FETCH_TEAM_NAME_REQUEST,
})

export const fetchTeamNameSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_TEAM_NAME_SUCCESS,
  payload,
})

export const fetchTeamNameFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_TEAM_NAME_FAILURE,
  payload,
})

export const fetchProgressRequest = (): ActionFormat => ({
  type: actionType.FETCH_PROGRESS_REQUEST,
})

export const fetchProgressSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_PROGRESS_SUCCESS,
  payload,
})

export const fetchProgressFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_PROGRESS_FAILURE,
  payload,
})

export const postLogoutRequest = (): ActionFormat => ({
  type: actionType.POST_LOGOUT_REQUEST,
})

export const postLogoutSuccess = (payload: any): ActionFormat => ({
  type: actionType.POST_LOGOUT_SUCCESS,
  payload,
})

export const postLogoutFailure = (payload: any): ActionFormat => ({
  type: actionType.POST_LOGOUT_FAILURE,
  payload,
})

export const fetchWellDoneBackgroundRequest = (payload: any): ActionFormat => ({
  type: actionType.FETCH_WELL_DONE_BACKGROUND_REQUEST,
  payload,
})

export const fetchWellDoneBackgroundSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_WELL_DONE_BACKGROUND_SUCCESS,
  payload,
})

export const fetchWellDoneBackgroundFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_WELL_DONE_BACKGROUND_FAILURE,
  payload,
})
export const setPuzzleAnswer = (data: any): ActionFormat => ({
  type: actionType.SET_PUZZLE_ANSWER,
  payload: data,
})
export const fetchGameConsentRequest = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAME_CONSENT_REQUEST,
  payload,
})

export const fetchGameConsentSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAME_CONSENT_SUCCESS,
  payload,
})

export const fetchGameConsentFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAME_CONSENT_FAILURE,
  payload,
})
export const fetchGameInstructionsRequest = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAME_INSTRUCTIONS_REQUEST,
  payload,
})

export const fetchGameInstructionsSuccess = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAME_INSTRUCTIONS_SUCCESS,
  payload,
})

export const fetchGameInstructionsFailure = (payload: any): ActionFormat => ({
  type: actionType.FETCH_GAME_INSTRUCTIONS_FAILURE,
  payload,
})
